/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LearnerProfileConceptInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

export interface GetReportsContextInterface {
  bookId: number;
  tocId?: number;
  classGroupIds?: number[];
  groupIds?: number[];
}

export interface GetReportsProgressInterface {
  classGroupId: number;
  classgroup: string;
  course: string;
  eduContentTocId: number;
  expertCompleted: boolean;
  expertProgress: number;
  expertStrandCompleted: boolean;
  masteringCompleted: boolean;
  masteringProgress: number;
  masteringStrandCompleted: boolean;
  module: string;
  personId: number;
  strandGuid: string;
  student: string;
}

@Injectable({ providedIn: 'root' })
export class AdaptemyApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Adaptemy');
  }

  public getReportsForClassGroup(
    classGroupId: number,
    context: GetReportsContextInterface
  ): Observable<{
    abilities: LearnerProfileConceptInterface[];
    progress: GetReportsProgressInterface[];
    classGroupId: number;
  }> {
    const url = 'reports-for-class-group';
    const params = this._getHttpParams({ classGroupId, context });

    return this.get(url, params);
  }

  public getReportsForGroup(
    groupId: number,
    context: GetReportsContextInterface
  ): Observable<{
    abilities: LearnerProfileConceptInterface[];
    progress: GetReportsProgressInterface[];
    groupId: number;
  }> {
    const url = 'reports-for-group';
    const params = this._getHttpParams({ groupId, context });

    return this.get(url, params);
  }

  public getReportsForContext(context: GetReportsContextInterface): Observable<{
    abilities: LearnerProfileConceptInterface[];
    progress: GetReportsProgressInterface[];
    classGroupIds: number[];
    groupIds: number[];
  }> {
    const url = 'reports-for-context';
    const params = this._getHttpParams({ context });

    return this.get(url, params);
  }
}
